export default __webpack_public_path__ + "static/media/helper-can-make.90c4e287.svg";